import { useIsAdmin } from '@/api/userAccount';
import { InlineAlert, InlineAlertBody, InlineAlertTitle } from '@/components/ui/InlineAlert';

export const NotForAdminsAlert = () => {
    if (!useIsAdmin()) {
        return <></>;
    }

    return (
        <InlineAlert severity="error" sx={{ m: 2 }}>
            <InlineAlertTitle>Not for Administrators</InlineAlertTitle>
            <InlineAlertBody>
                This page does not support admin users. Don&apos;t expect anything to work in here.
            </InlineAlertBody>
        </InlineAlert>
    );
};
